import { Col, Modal, Row, Table } from "react-bootstrap";
import { PatientVisit } from "../../amplify/appsync/search-patients";

import { faExclamationTriangle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { callRiskScorePrediction } from "../../amplify/appsync/risk-score-prediction";

/**
 * Modal showing details on the Epic risk score calculation
 */
export const EpicRiskScoreModal = (props: {
    showModal: boolean,
    setShowModal: any,
    patientVisit: PatientVisit,
}) => {

    const [loading, setLoading] = useState(false);
    const [riskScore, setRiskScore] = useState<any>();

    useEffect(() => {
        if (props.showModal) {
            setLoading(true);
            callRiskScorePrediction({
                csn: props.patientVisit.csn,
                risk_type: "epic_risk_score",
            }).then((val) => {
                const rawOutput = JSON.parse(val);
                if (rawOutput["body"]) {
                    setLoading(false);
                    const output = JSON.parse(rawOutput["body"])
                    setRiskScore(output);
                }
            });
        }
    }, [props.showModal]);

    return (
        <Modal show={props.showModal} dialogClassName="modal-90w" onHide={() => props.setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Epic Risk Score</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={3}>
                        {
                            !loading && riskScore && (
                                <h2 style={{color: riskScore.model_prediction[0] >= 0.5 ? "red" : undefined}}>{Math.round(riskScore.model_prediction[0] * 1000) / 1000} {riskScore.model_prediction[0] >= 0.5 && <FontAwesomeIcon icon={faExclamationTriangle} />}</h2>
                            )
                        }
                    </Col>
                    <Col md={9}>
                        {
                            loading ? (
                                <Row>
                                    <Col>
                                        <FontAwesomeIcon icon={faSpinner} spin />{' '}Loading...
                                    </Col>
                                </Row>
                            ) : (
                                <Row>
                                    <Col>
                                        <h5>Score Contributions</h5>
                                        {
                                            riskScore && (
                                                riskScore["criteria"].map((score: any) => (
                                                    <>
                                                        {
                                                            score.type === "ccs" && (
                                                                <h6>{score.ccs_diagnoses} (CCS {score.ccs})</h6>
                                                            )
                                                        }
                                                        {
                                                            score.type === "total_encounters" && (
                                                                <h6>Total Hospital Encounters (past year): {score.total_encounters}</h6>
                                                            )
                                                        }
                                                        {
                                                            score.type === "total_ed_visits" && (
                                                                <h6>Total ED Visits (past year): {score.total_ed_visits}</h6>
                                                            )
                                                        }
                                                        {
                                                            score.type === "ccs" && (
                                                                <Table striped bordered hover size="sm" style={{fontSize: '0.8rem'}}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Last Observed CSN</th>
                                                                            <th>Last Observed Time</th>
                                                                            <th>Abatement</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            <tr>
                                                                                <td>{score.ccs_to_info.csn}</td>
                                                                                <td>{score.ccs_to_info.last_observed ? score.ccs_to_info.last_observed : score.ccs_to_info.recorded_time ? score.ccs_to_info.recorded_time : "-"}</td>
                                                                                <td>{score.ccs_to_info.abatement_time ? score.ccs_to_info.abatement_time : "-"}</td>
                                                                            </tr>
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            )
                                                        }
                                                    </>
                                                ))
                                            )
                                        }
                                    </Col>
                                </Row>
                            )
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};
